@layer reset, default, display, limit, margin, role, size, style, weight;

@layer reset {
  :host {
    display: block;
    color: var(--gcds-text-role-primary);

    .gcds-text {
      display: inherit;
      box-sizing: border-box;
      margin: 0;

      slot {
        display: initial;
      }
    }
  }
}

@layer default {
  :host .gcds-text {
    font: var(--gcds-text-size-body-desktop);

    @media only screen and (width < 48em) {
      font: var(--gcds-text-size-body-mobile);
    }
  }
}

@layer display {
  :host {
    &.d-block {
      display: block;
    }

    &.d-flex {
      display: flex;
    }

    &.d-inline {
      display: inline;
    }

    &.d-inline-block {
      display: inline-block;
    }

    &.d-inline-flex {
      display: inline-flex;
    }

    &.d-none {
      display: none;
    }
  }
}

@layer limit {
  :host .gcds-text.limit {
    max-width: var(--gcds-text-character-limit);
  }
}

@layer margin {
  :host .gcds-text {
    /* Margin top */
    &.mt-0 {
      margin-block-start: var(--gcds-text-spacing-0);
    }

    &.mt-25 {
      margin-block-start: var(--gcds-text-spacing-25);
    }

    &.mt-50 {
      margin-block-start: var(--gcds-text-spacing-50);
    }

    &.mt-75 {
      margin-block-start: var(--gcds-text-spacing-75);
    }

    &.mt-100 {
      margin-block-start: var(--gcds-text-spacing-100);
    }

    &.mt-125 {
      margin-block-start: var(--gcds-text-spacing-125);
    }

    &.mt-150 {
      margin-block-start: var(--gcds-text-spacing-150);
    }

    &.mt-175 {
      margin-block-start: var(--gcds-text-spacing-175);
    }

    &.mt-200 {
      margin-block-start: var(--gcds-text-spacing-200);
    }

    &.mt-225 {
      margin-block-start: var(--gcds-text-spacing-225);
    }

    &.mt-250 {
      margin-block-start: var(--gcds-text-spacing-250);
    }

    &.mt-300 {
      margin-block-start: var(--gcds-text-spacing-300);
    }

    &.mt-350 {
      margin-block-start: var(--gcds-text-spacing-350);
    }

    &.mt-400 {
      margin-block-start: var(--gcds-text-spacing-400);
    }

    &.mt-450 {
      margin-block-start: var(--gcds-text-spacing-450);
    }

    &.mt-500 {
      margin-block-start: var(--gcds-text-spacing-500);
    }

    &.mt-550 {
      margin-block-start: var(--gcds-text-spacing-550);
    }

    &.mt-600 {
      margin-block-start: var(--gcds-text-spacing-600);
    }

    &.mt-650 {
      margin-block-start: var(--gcds-text-spacing-650);
    }

    &.mt-700 {
      margin-block-start: var(--gcds-text-spacing-700);
    }

    &.mt-750 {
      margin-block-start: var(--gcds-text-spacing-750);
    }

    &.mt-800 {
      margin-block-start: var(--gcds-text-spacing-800);
    }

    &.mt-850 {
      margin-block-start: var(--gcds-text-spacing-850);
    }

    &.mt-900 {
      margin-block-start: var(--gcds-text-spacing-900);
    }

    &.mt-950 {
      margin-block-start: var(--gcds-text-spacing-950);
    }

    &.mt-1000 {
      margin-block-start: var(--gcds-text-spacing-1000);
    }

    &.mt-1050 {
      margin-block-start: var(--gcds-text-spacing-1050);
    }

    &.mt-1100 {
      margin-block-start: var(--gcds-text-spacing-1100);
    }

    &.mt-1150 {
      margin-block-start: var(--gcds-text-spacing-1150);
    }

    &.mt-1200 {
      margin-block-start: var(--gcds-text-spacing-1200);
    }

    &.mt-1250 {
      margin-block-start: var(--gcds-text-spacing-1250);
    }

    /* Margin bottom */
    &.mb-0 {
      margin-block-end: var(--gcds-text-spacing-0);
    }

    &.mb-25 {
      margin-block-end: var(--gcds-text-spacing-25);
    }

    &.mb-50 {
      margin-block-end: var(--gcds-text-spacing-50);
    }

    &.mb-75 {
      margin-block-end: var(--gcds-text-spacing-75);
    }

    &.mb-100 {
      margin-block-end: var(--gcds-text-spacing-100);
    }

    &.mb-125 {
      margin-block-end: var(--gcds-text-spacing-125);
    }

    &.mb-150 {
      margin-block-end: var(--gcds-text-spacing-150);
    }

    &.mb-175 {
      margin-block-end: var(--gcds-text-spacing-175);
    }

    &.mb-200 {
      margin-block-end: var(--gcds-text-spacing-200);
    }

    &.mb-225 {
      margin-block-end: var(--gcds-text-spacing-225);
    }

    &.mb-250 {
      margin-block-end: var(--gcds-text-spacing-250);
    }

    &.mb-300 {
      margin-block-end: var(--gcds-text-spacing-300);
    }

    &.mb-350 {
      margin-block-end: var(--gcds-text-spacing-350);
    }

    &.mb-400 {
      margin-block-end: var(--gcds-text-spacing-400);
    }

    &.mb-450 {
      margin-block-end: var(--gcds-text-spacing-450);
    }

    &.mb-500 {
      margin-block-end: var(--gcds-text-spacing-500);
    }

    &.mb-550 {
      margin-block-end: var(--gcds-text-spacing-550);
    }

    &.mb-600 {
      margin-block-end: var(--gcds-text-spacing-600);
    }

    &.mb-650 {
      margin-block-end: var(--gcds-text-spacing-650);
    }

    &.mb-700 {
      margin-block-end: var(--gcds-text-spacing-700);
    }

    &.mb-750 {
      margin-block-end: var(--gcds-text-spacing-750);
    }

    &.mb-800 {
      margin-block-end: var(--gcds-text-spacing-800);
    }

    &.mb-850 {
      margin-block-end: var(--gcds-text-spacing-850);
    }

    &.mb-900 {
      margin-block-end: var(--gcds-text-spacing-900);
    }

    &.mb-950 {
      margin-block-end: var(--gcds-text-spacing-950);
    }

    &.mb-1000 {
      margin-block-end: var(--gcds-text-spacing-1000);
    }

    &.mb-1050 {
      margin-block-end: var(--gcds-text-spacing-1050);
    }

    &.mb-1100 {
      margin-block-end: var(--gcds-text-spacing-1100);
    }

    &.mb-1150 {
      margin-block-end: var(--gcds-text-spacing-1150);
    }

    &.mb-1200 {
      margin-block-end: var(--gcds-text-spacing-1200);
    }

    &.mb-1250 {
      margin-block-end: var(--gcds-text-spacing-1250);
    }
  }
}

@layer variants.role {
  :host .gcds-text {
    &.role-primary {
      color: var(--gcds-text-role-primary);
    }

    &.role-secondary {
      color: var(--gcds-text-role-secondary);
    }

    &.role-light {
      color: var(--gcds-text-role-light);
    }
  }
}

@layer variants.size {
  :host .gcds-text.size-small,
  :host .gcds-text :is(small, ::slotted(small)) {
    font: var(--gcds-text-size-small-desktop);

    @media only screen and (width < 48em) {
      font: var(--gcds-text-size-small-mobile);
    }
  }
}

@layer variants.style {
  :host .gcds-text ::slotted(em) {
    font-style: italic;
  }
}

@layer variants.weight {
  :host .gcds-text ::slotted(strong) {
    font-weight: var(--gcds-text-weight-bold);
  }
}
